import React from 'react';

/**
 * TikTok-style live NLT logo watermark, pinned to the bottom-left corner of the
 * media it sits over. Must be placed inside a `position: relative` parent.
 * pointer-events-none so it never blocks video controls or taps.
 */
export const NLTWatermark = ({ size = 'md', className = '' }) => {
  const w = size === 'xs' ? 'w-7' : size === 'sm' ? 'w-10' : size === 'lg' ? 'w-24' : 'w-16';
  return (
    <img
      src="/nlt-radio-logo.png"
      alt="NLT Radio"
      aria-hidden="true"
      draggable={false}
      className={`absolute bottom-2 left-2 ${w} h-auto opacity-70 drop-shadow-[0_1px_5px_rgba(0,0,0,0.7)] pointer-events-none select-none z-30 ${className}`}
      data-testid="nlt-watermark"
    />
  );
};

export default NLTWatermark;
